<i18n lang='yml' src='../i18n/UserSelection.yml'></i18n>

<template>
    <div>
        <h4 class='dark-blue-bg heading-block d-flex mb-0 user-selection'>
            {{ header }}
            <template v-if="!loadingComponent">
                <template v-if='canToggle()'>
                    <div class='btn-group btn-group-xs ml-auto' role="group" :aria-label="$t('user_selection_buttons')">
                        <button type='button' class='btn btn-primary'
                                data-toggle='tooltip' :data-original-title='$t("select_all.tooltip")'
                                v-on:click='toggleSelection'>
                            <span v-if="users.length === selectedUsers.length">
                              <font-awesome-icon :icon="['far', 'dot-circle']" aria-hidden='true'/>
                            </span>
                            <span v-if="users.length !== selectedUsers.length">
                              <font-awesome-icon :icon="['far', 'circle']" aria-hidden='true'/>
                            </span>
                            <span class='d-md-none d-lg-none'>{{ $t('select_all.text') }}</span>
                        </button>
                    </div>
                </template>
            </template>
        </h4>
        <div class='row layout-grid'>
            <div v-if="loadingComponent">
              {{ $t('loading') }}
            </div>
            <div v-else class='col-xs-12 col-sm-12 col-md-4 col-lg-4' v-for='user in users'>
                <div class='media item-select' v-bind:class='{ "active": selectedUsers.includes(user.id), "blue-bg": (!canAdd || !canRemove) && selected.includes(user.id) }'>
                    <div class='media-body' style='word-break: break-word;'>
                        <h5>{{ user.name }}</h5>
                        <input type='checkbox' class='sr-only' :id='"user" + user.id' :name='fieldName + "[user_ids][]"' :value='user.id' v-model='selectedUsers' v-on:click.capture='validateClick'>
                        <label :for='"user" + user.id'>&nbsp;</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            locale: { type: String },
            endpoint: { type: String },
            fieldName: { type: String },
            selected: { type: Array, default: [] },
            header: { type: String },
            canAdd: { type: Boolean, default: true },
            canRemove: { type: Boolean, default: true }
        },
        data () {
            return {
              users: [],
              selectedUsers: this.selected,
              loadingComponent: true,
            }
        },
        mounted () {
            this.$i18n.locale = this.locale;
            const _vm = this;
            $.getJSON({
                url: _vm.endpoint,
                success: function (data) {
                  _vm.users = data;
                  _vm.loadingComponent = false;
                }
            });
        },
        methods: {
            canToggle: function () {
                if (this.selectedUsers.length === this.users.length) {
                    return this.canRemove;
                } else {
                    return this.canAdd;
                }
            },
            toggleSelection: function () {
                if (this.selectedUsers.length === this.users.length) {
                    this.selectedUsers = [];
                } else {
                    this.selectedUsers = this.users.map(function (user) {
                        return user.id
                    });
                }
            },
            validateClick: function (event) {
                if (event.target.checked && !this.canAdd) {
                    event.target.checked = false;
                } else if (!event.target.checked && !this.canRemove && this.selected.includes(parseInt(event.target.value, 10))) {
                    event.target.checked = true;
                }
            }
        }
    }
</script>
